
import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { StoreModel } from '@/models/store';
import ActionButton from '@/components/ActionButton.vue';

// Add this to the top of the file, before import statements
// This declares the $permissionService property on the Vue prototype
declare module 'vue/types/vue' {
  interface Vue {
    $permissionService: any;
  }
}

@Component({
  components: {
    ActionButton
  }
})
export default class Permission extends Vue {
  @Prop({ type: String, required: true }) feature!: string;
  @Prop({ type: Boolean, default: true }) showFallback!: boolean;
  @Prop({ type: Boolean, default: true }) upgradable!: boolean;
  @Prop({ type: String, default: 'This feature requires a higher subscription level.' }) 
  fallbackMessage!: string;
  @Prop({ type: Boolean, default: false }) isPageStyle!: boolean;
  @Prop({ type: String, default: 'Feature Locked' }) pageTitle!: string;
  
  // Inject the store from App.vue
  @Inject() store!: StoreModel;

  get hasPermission(): boolean {
    try {
      // Check if we're still initializing permissions - allow access during this time
      if (Vue.prototype.$permissionsInitializing === true) {
        return true; // Show permission UI while initializing
      }
      
      // Use $permissionService if available, otherwise fall back to direct store check
      if (this.$permissionService) {
        const result = this.$permissionService.hasPermission(this.feature);
        return result;
      } else if (this.store) {
        // Use the injected store
        return this.store.isValidateRule(this.feature, 'unlocked') || false;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }
}
